import { Component, AfterViewInit } from '@angular/core';
import { SYSCONF_SIGLA } from 'src/app.api';
declare var $:any;
@Component({
	templateUrl: './pessoaInstituicaoVideo.component.html',
})
export class pessoaInstituicaoVideoComponent implements AfterViewInit{
	sigla = SYSCONF_SIGLA;
	constructor(){}

	ngAfterViewInit() {
		$(".preloader").fadeOut();
	 }
}
